<template>
	<div class="tool-block-editor">
		<v-row no-gutters class="editor_top_bar" style="height: 70px; background: #fcfcfd; z-index: 3">
			<v-col cols="12">
				<BlockEditorTopHeader :showParams="true" :integrationSelector="false" headerIcons="link-clicked" />
			</v-col>
		</v-row>
		<div class="px-6 fields">
			<component :is="toolPlacementEditorComponent" :workflow="editWorkflow" :loading="loading" @save-workflow="saveWorkflow" />
		</div>
	</div>
</template>
<script>
import BlockEditorTopHeader from '@/components/BlockEditor/BlockEditorTopHeader';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { immediateUpdateWorkflow } from '@/store/modules/selectedWorkflow/actions';
import WorkflowToolService from '@/utils/workflow-tool-service';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import URLToolPlacementEditor from './ToolPlacementEditors/URLToolPlacementEditor.vue';
import CommandBarToolPlacementEditor from './ToolPlacementEditors/CommandBarToolPlacementEditor.vue';
import SlackToolPlacementEditor from './ToolPlacementEditors/SlackToolPlacementEditor.vue';
export default {
	name: 'BlockEditorToolBlock',
	components: {
		BlockEditorTopHeader,
	},
	computed: {
		...mapGettersShorthand({ editWorkflow }),
		isToolOfURL() {
			return WorkflowToolService.isURLTool(this.editWorkflow);
		},
		isToolOfCommandBar() {
			return WorkflowToolService.isCommandBarTool(this.editWorkflow);
		},
		isToolOfSlack() {
			return WorkflowToolService.isSlackTool(this.editWorkflow);
		},
		toolPlacementEditorComponent() {
			if (this.isToolOfURL) {
				return URLToolPlacementEditor;
			} else if (this.isToolOfCommandBar) {
				return CommandBarToolPlacementEditor;
			} else if (this.isToolOfSlack) {
				return SlackToolPlacementEditor;
			}
			return null;
		},
	},
	methods: {
		...mapActionsShorthand({ immediateUpdateWorkflow }),
		async saveWorkflow(workflow) {
			this.loading = true;
			try {
				await this.immediateUpdateWorkflow({ data: workflow });
			} finally {
				this.loading = false;
			}
		},
	},
	data() {
		return {
			loading: false,
		};
	},
};
</script>
<style scoped>
.tool-block-editor {
	width: var(--base-width);
}
</style>
